module.exports = __webpack_public_path__ + "img/creditCard.c8805c5a.svg";